/**------------------------------------------------------
 * Interfaces
 */
export interface IPaymentInvoiceToMailRequest {
	invoiceUrl	: string;
	email		: string;
	paymentId	: string;
	paymentDate	: Date;
}
